<script>
  import { useQuery } from "@sveltestack/svelte-query";
  import superagent from "superagent";

  import { locale, locales, _ } from "svelte-i18n";

  export let trainer = {};
  export let refetch;

  let showDetails = false;
  function toggle() {
    showDetails = !showDetails;
  }

  const storedUser = localStorage.getItem("user");

  let env;
  let user =
    storedUser !== null
      ? JSON.parse(storedUser)
      : {
          name: "",
          surname: "",
          email: "",
          countryCode: "47",
          phone: "",
          club: "",
          school: "",
          gender: "",
          birthDate: "",
        };
  const currentUser = useQuery("me-profile", () =>
    user.id !== undefined
      ? superagent
          .get("/api/me")
          .set("Authorization", "Bearer " + user.id)
          .then((response) => {
            env = response.headers.environment;
            return response.body;
          })
      : superagent.get("/api/me").end((err, response) => {
          env = response.headers.environment;
        })
  );

  $: if (
    !$currentUser.isLoading &&
    $currentUser.data &&
    user !== undefined &&
    user.version !== $currentUser.data.version
  ) {
    user = $currentUser.data;
    localStorage.setItem("user", JSON.stringify(user));
  }

  function deleteTrainer(trainerId) {
    console.log("[INFO] Delete trainer", trainerId);
    superagent
      .delete("/api/trainers/" + trainerId)
      .set("Authorization", "Bearer " + user.id)
      .then((response) => {
        console.log("[INFO] Trainer deleted", response);
        refetch?.();
      })
      .catch((error) => {
        console.log("[ERROR] Not able to delete trainer", error);
      });
  }
</script>

<div>
  <li
    style="display: flex; align-items: center; flex-direction: row; cursor: pointer;"
    on:click={toggle}
  >
    {trainer.name}
    {trainer.surname} - {trainer.club}
    <button
      aria-label="Show details"
      on:click={(e) => {
        e.stopPropagation();
        toggle();
      }}
      type="button"
      class="button-text button-text--chevron-down {showDetails
        ? 'is-toggled'
        : ''}"
      style="margin-left: 0px; margin-top: 18px;"
    ></button>
  </li>
  {#if showDetails}
    <div>
      <p style="margin-bottom: 0px;">{$_("profile.access.canAccess.title")}</p>
      <ul class="list-bullets">
        <li>
          {$_("profile.access.canAccess.session") +
            " - " +
            (trainer.access.viewSession ? "✓" : "✖")}
        </li>
        <li>
          {$_("profile.access.canAccess.viewMenstruation") +
            " - " +
            (trainer.access.viewMenstruation ? "✓" : "✖")}
        </li>
        <li>
          {$_("profile.access.canAccess.viewSleep") +
            " - " +
            (trainer.access.viewSleep ? "✓" : "✖")}
        </li>
        <li>
          {$_("profile.access.canAccess.viewRestingPulse") +
            " - " +
            (trainer.access.viewRestingPulse ? "✓" : "✖")}
        </li>
        <li>
          {$_("profile.access.canAccess.canComment") +
            " - " +
            (trainer.access.canComment ? "✓" : "✖")}
        </li>
        <button
          style="cursor:pointer; color:red; display: inline; border: 1px solid red; padding: 0 5px; border-radius: 5px; background: none; margin-top: 10px;"
          on:click={() => deleteTrainer(trainer.id)}
        >
          {$_("profile.access.removeAccess")}
        </button>
      </ul>
    </div>
  {/if}
</div>
